var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDots24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 7.5C13.3284 7.5 14 6.82843 14 6C14 5.17157 13.3284 4.5 12.5 4.5C11.6716 4.5 11 5.17157 11 6C11 6.82843 11.6716 7.5 12.5 7.5ZM12.5 13.5C13.3284 13.5 14 12.8284 14 12C14 11.1716 13.3284 10.5 12.5 10.5C11.6716 10.5 11 11.1716 11 12C11 12.8284 11.6716 13.5 12.5 13.5ZM14 18C14 18.8284 13.3284 19.5 12.5 19.5C11.6716 19.5 11 18.8284 11 18C11 17.1716 11.6716 16.5 12.5 16.5C13.3284 16.5 14 17.1716 14 18Z",
    fill: "#2767A9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots24);
export default __webpack_public_path__ + "static/media/Dots24.1a7f7a58ac1821934b7884112bfb7544.svg";
export { ForwardRef as ReactComponent };